import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

export function AddUserIcon({ className, fill, height, width }: SimpleIconInterface) {
  const clipPathId = useSvgId('add-user-clip');

  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'none'}
      height={height ?? '16'}
      viewBoxDimensions="0 0 16 16"
      width={width ?? '16'}
    >
      <g clipPath={`url(#${clipPathId})`} id="Frame">
        <g id="Group">
          <path
            d="M6.66667 7.33333C8.69171 7.33333 10.3333 5.69171 10.3333 3.66667C10.3333 1.64162 8.69171 0 6.66667 0C4.64162 0 3 1.64162 3 3.66667C3 5.69171 4.64162 7.33333 6.66667 7.33333Z"
            fill="#B3B3B3"
            id="Vector"
          />
          <path
            d="M6.66667 8.66663C2.99067 8.66663 0 11.6573 0 15.3333C0 15.702 0.298667 16 0.666667 16H12.6667C13.0347 16 13.3333 15.702 13.3333 15.3333C13.3333 11.6573 10.3427 8.66663 6.66667 8.66663Z"
            fill="#B3B3B3"
            id="Vector_2"
          />
          <path
            d="M15.6667 6.66663H14V4.99996C14 4.81596 13.8507 4.66663 13.6667 4.66663H13C12.816 4.66663 12.6667 4.81596 12.6667 4.99996V6.66663H11C10.816 6.66663 10.6667 6.81596 10.6667 6.99996V7.66663C10.6667 7.85063 10.816 7.99996 11 7.99996H12.6667V9.66663C12.6667 9.85063 12.816 9.99996 13 9.99996H13.6667C13.8507 9.99996 14 9.85063 14 9.66663V7.99996H15.6667C15.8507 7.99996 16 7.85063 16 7.66663V6.99996C16 6.81596 15.8507 6.66663 15.6667 6.66663Z"
            fill="#B3B3B3"
            id="Vector_3"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
